import React, { useState } from 'react';
import { Text, View } from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { TRootStackParamList } from 'app/types/navigation';
import { useTranslation } from 'react-i18next';
import { PdfViewer } from '../shared/components/PdfViewer';
import { useNavigation } from '@react-navigation/native';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';

type Props = NativeStackScreenProps<TRootStackParamList, 'PdfDocumentPage'>;

export const PdfDocument = (params: Props) => {
  const { pdfUrl } = params.route.params;
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const navigation = useNavigation();

  const handleGoBack = () => {
    navigation.goBack();
  };

  if (!pdfUrl) {
    return (
      <View>
        <Text>{t('commons.connection.failedToConnect')}</Text>
      </View>
    );
  }

  const handleError = (error: any) => {
    setError(t('commons.connection.connectionError'));
  };

  const handleLoadComplete = (pages: number) => {
    setError(null);
  };

  return (
    <MainLayout navigation={handleGoBack}>
      <PdfViewer
        pdfUrl={pdfUrl}
        onError={handleError}
        onLoadComplete={handleLoadComplete}
      />
    </MainLayout>
  );
};
